export function toDateInputValue(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function toTimeInputValue(date: Date): string {
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${h}:${min}`;
}

export function splitDateTimeLocalValue(value: string): { date: string; time: string } {
  if (!value || !value.includes('T')) {
    return { date: '', time: '' };
  }

  const [date, timePart] = value.split('T');
  return { date: date ?? '', time: (timePart ?? '').slice(0, 5) };
}

export function combineDateTimeLocal(date: string, time: string, defaultTime = '18:00'): string {
  if (!date.trim()) {
    return '';
  }

  const normalizedTime = time.trim() || defaultTime;
  return `${date}T${normalizedTime}`;
}

export function getMinDateForInput(minDateTime?: Date): string {
  const ref = minDateTime ?? new Date();
  return toDateInputValue(ref);
}

export function getMinTimeForDate(selectedDate: string, minDateTime?: Date): string | undefined {
  if (!selectedDate) {
    return undefined;
  }

  const ref = minDateTime ?? new Date();
  const today = toDateInputValue(ref);
  if (selectedDate !== today) {
    return undefined;
  }

  const nextMinute = new Date(ref.getTime() + 60_000);
  return toTimeInputValue(nextMinute);
}

export function formatDateTimeLocalPreview(value: string): string {
  if (!value) {
    return '';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }

  return new Intl.DateTimeFormat('pt-BR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(parsed);
}

export function isDateTimeLocalInPast(value: string, reference = new Date()): boolean {
  if (!value) {
    return false;
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return false;
  }

  return parsed.getTime() <= reference.getTime();
}

const NATIVE_PICKER_INDICATOR_WIDTH_PX = 40;

export function isNativePickerIndicatorClick(input: HTMLInputElement, clientX: number): boolean {
  const rect = input.getBoundingClientRect();
  const clickOffsetX = clientX - rect.left;
  const isRtl = getComputedStyle(input).direction === 'rtl';

  if (isRtl)
  {
    return clickOffsetX <= NATIVE_PICKER_INDICATOR_WIDTH_PX;
  }

  return clickOffsetX >= rect.width - NATIVE_PICKER_INDICATOR_WIDTH_PX;
}

export function openNativePicker(input: HTMLInputElement | null): void {
  if (!input || input.disabled) {
    return;
  }

  if (document.activeElement !== input) {
    input.focus();
  }

  if (typeof input.showPicker === 'function') {
    try {
      input.showPicker();
    } catch {
      // Alguns navegadores rejeitam showPicker fora de gesto do usuário.
    }
  }
}
